/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';

const styles = {
};

export = styles;

loadStyles([{"rawString":".ms-IconExample{font-size:50px;margin-left:25px;margin-right:25px}.ms-IconColorExample-deepSkyBlue{color:#00bfff}.ms-IconColorExample-greenYellow{color:#adff2f}.ms-IconColorExample-salmon{color:salmon}.ms-IconImageSheetExample-one{width:48px;height:44px;margin-left:27px}.ms-IconImageSheetExample-one-image{display:inline-block;position:relative;left:-6px;top:-4px}.ms-IconImageSheetExample-check{width:35px;height:43px;margin-left:55px}.ms-IconImageSheetExample-check-image{display:inline-block;position:relative;left:-60px;top:-5px}.ms-IconImageSheetExample-lock{width:35px;height:42px;margin-left:65px}.ms-IconImageSheetExample-lock-image{display:inline-block;position:relative;left:-109px;top:-5px}"}]);
/* tslint:enable */